import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faDatabase,
    faHeartbeat,
    faServer,
    faUpload,
    faStream,
    faRocket,
    faNewspaper,
} from '@fortawesome/free-solid-svg-icons';

import { PracticeListPermissionsContext } from '../PracticesList';

const getComponentIconStyle = (componentStatus) => {
    switch (componentStatus) {
        case 'None':
            return 'secondary';
        case 'Active':
            return 'primary';
        case 'Error':
            return 'danger';
        case 'Success':
            return 'success';
        default:
            return 'secondary';
    }
};

// TODO: find where the practice prop is used and force use of primitives
export const StatusIcons = ({
    allowConversionPrep,
    allowLeadsGeneration,
    size = 'lg',
    status,
    isCloudPims,
}) => {
    const { canSeePracticeListStatusIcons } = useContext(
        PracticeListPermissionsContext
    );

    if (
        !canSeePracticeListStatusIcons ||
        status === undefined ||
        status === null
    )
        return <></>;

    const {
        partiallyActive,
        heartbeatStatus,
        missionControlStatus,
        extractionStatus,
        stagingLoadStatus,
        intermediateLoadStatus,
        conversionPrepStatus,
        leadsGenerationStatus,
    } = status;

    return (
        <>
            <FontAwesomeIcon
                size={size}
                icon={faHeartbeat}
                className={`text-${getComponentIconStyle(heartbeatStatus)} m-1`}
                title="Connectivity"
            />
            <FontAwesomeIcon
                size={size}
                icon={faRocket}
                className={`text-${getComponentIconStyle(
                    missionControlStatus
                )} m-1`}
                title="Mission Control"
            />
            <FontAwesomeIcon
                size={size}
                icon={faUpload}
                className={`text-${getComponentIconStyle(
                    extractionStatus
                )} m-1`}
                title="Sync"
            />
            {!isCloudPims && (
                <FontAwesomeIcon
                    size={size}
                    icon={faDatabase}
                    className={`text-${getComponentIconStyle(
                        stagingLoadStatus
                    )} m-1`}
                    title="Staging"
                />
            )}
            <FontAwesomeIcon
                size={size}
                icon={faServer}
                className={`text-${getComponentIconStyle(
                    intermediateLoadStatus
                )} m-1`}
                title="Intermediate"
            />
            {allowConversionPrep && (
                <FontAwesomeIcon
                    size={size}
                    icon={faStream}
                    className={`text-${getComponentIconStyle(
                        conversionPrepStatus
                    )} m-1`}
                    title="ConversionPrep"
                />
            )}
            {allowLeadsGeneration && (
                <FontAwesomeIcon
                    size={size}
                    icon={faNewspaper}
                    className={`text-${getComponentIconStyle(
                        leadsGenerationStatus
                    )} m-1`}
                    title="Leads Generation"
                />
            )}
        </>
    );
};
